class EsAirtaskerInstall extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      modalContent: ".es-airtasker-install-modal",
      openBtn: "[data-open-airtasker-install]",
      closeBtn: "[data-close-airtasker-install]",
      link: "[data-airtasker-link]",
      banner: ".es-airtasker-install"
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    this.productType = this.dataset.productType || "";
    this.watchForView();

    const { modalContent } = this.domNodes;
    if (modalContent && modalContent.innerHTML) {
      this.modalContent = modalContent.innerHTML;
      this.init();
    }
  }

  // GA4. The denominator for the open rate is the view event, not a page view:
  // the banner sits well down the buy box and plenty of sessions never reach it.
  track(eventName, clarityStage) {
    try {
      es_analytics(4, eventName, {
        location: "pdp_buybox",
        product_type: this.productType
      });
    } catch (e) {
      console.error(e);
    }

    // Clarity custom tag, so the recordings worth watching can be found at all:
    // its filters have no notion of "clicked the banner", and only a few percent
    // of sessions will have. Counts stay with GA4 - Clarity's delayed load drops
    // short sessions, and its API cannot read custom tags back.
    //
    // Clarity loads 3s after window.load (layout/theme.liquid), so queue through
    // the same stub shape its own loader uses: c[a]=c[a]||... keeps this queue
    // rather than replacing it, and clarity.js drains window.clarity.q on arrival.
    try {
      window.clarity =
        window.clarity ||
        function () {
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
      window.clarity("set", "airtasker_pdp_banner", clarityStage);
    } catch (e) {
      console.error(e);
    }
  }

  watchForView() {
    const banner = this.querySelector(this.selectors.banner);
    if (!banner || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          this.track("es_airtasker_view", "view");
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(banner);
  }

  init() {
    this.modal = new MinimogTheme.Modal();

    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        this.track("es_airtasker_open", "open");
        if (this.modalContent) {
          const contentElement = document.createElement("DIV");
          contentElement.classList.add("es-airtasker-install-content");
          contentElement.innerHTML = this.modalContent;

          this.modal.appendChild(contentElement);
          this.modal.setSizes("es-airtasker-install-modal");
          this.modal.open();
        }
      }
    });

    // "Got it, back to shopping" closes the modal the same way ESC does.
    addEventDelegate({
      selector: this.selectors.closeBtn,
      handler: (e) => {
        e.preventDefault();
        this.modal.close();
      }
    });

    // Delegated, because the link the visitor clicks is the copy inside the
    // modal, not the one in the template. It opens in a new tab, so the beacon
    // is not racing a navigation.
    addEventDelegate({
      selector: this.selectors.link,
      handler: () => this.track("es_airtasker_link", "link")
    });
  }
}

customElements.define("es-airtasker-install", EsAirtaskerInstall);
